<template>
  <VeterinarList :key="`catalog-${$route.fullPath}`"/>
</template>

<script lang="ts" setup>
definePageMeta({
  key: (route) => route.fullPath,
})
</script>
